export const child_tracking_message = {
    errorMessageForGettingInitialDetails : "Error in getting Service List",
    errorMessageForGettingSubList: "Error in Expanding the Service"
}

export const child_immunization_message = {
    errorMessageForAdverseDetails : "Adverse Effect cannot be kept empty. Select a valid option",
    errorMessageFordeathByAEFI: "Death Following AEFI cannot be kept empty. Select a valid option",
    errorMessageFordeathDate: "Select a date"
}


export const AUTH_TYPES = {
  DEMOGRAPHICS: 'Demographics',
  OTP: 'OTP',
};

export const BENEFICIARY_OPTIONS = {
  AADHAAR: 'Aadhaar',
  ABHA: 'ABHA',
  PHONE_NUMBER: 'Phone_Number',
};

export const CHILD_REGISTRATION_KEYS = {
  BAAL_ABHA_USING_PARENTS: 'baal_abha_using_parents_details',
};